import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Observable, Subscription} from 'rxjs';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
  selector: 'app-bar-chart-stable-unstable-uc',
  templateUrl: './bar-chart-stable-unstable-uc.component.html',
  styleUrls: ['./bar-chart-stable-unstable-uc.component.css']
})
export class BarChartStableUnstableUCComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  title = "Pazienti stabili/instabili";
  destination = 'general-status';
  isDataAvailable = false;
  // ****************************************************************************************************************
  // Bar chart dei pazienti globali in miglioramento, in peggioramento e stabili per i malati di Rettocolite ulcerosa
  // *****************************************************************************************************************
  stabiliRecidivaUC = [];
  stabiliRemissioneUC = [];
  instabiliMiglRecidivaUC = [];
  instabiliPegRecidivaUC = [];
  instabiliMiglRemissioneUC = [];
  instabiliPegRemissioneUC = [];
  // vettori per il grafico
  UCRemissione = []; // stabili, miglioramento, peggioramento
  UCRecidiva = []; // stabili, miglioramento, peggioramento
  // stable and unstable UC patients bar chart
  canvas: any;
  ctx: any;
  myChartUCStableUnstable: Chart;
  // stabili recidiva table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // opzioni per il bar chart
  public barChartUCStableUnstableType = 'bar';
  public barChartUCStableUnstableLabels = ['STABILI', 'IN MIGLIORAMENTO', 'IN PEGGIORAMENTO'];
  public barChartUCStableUnstableData = [{
    data: this.UCRecidiva,
    barThickness: 70,  // number (pixels) or 'flex'
    backgroundColor: ['#ff5232', '#ff5232', '#ff5232'],
    hoverBackgroundColor: ['#d11507', '#d11507', '#d11507'],
    label: 'RECIDIVA',
    datalabels: {
      color: 'white', // Color for percentage value
    }
  }, {
    data: this.UCRemissione,
    barThickness: 70,  // number (pixels) or 'flex'
    backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e'],
    hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c'],
    label: 'REMISSIONE',
    datalabels: {
      color: 'white' // Color for percentage value}
    }
  }];
  // TABELLE DISPONIBILI
  isHovered = false;
  TableTitle: string;
  isTableStabiliRecidivaAvailable = false;
  isTableMiglRecidivaAvailable = false;
  isTablePegRecidivaAvailable = false;
  isTableStabiliRemissioneAvailable = false;
  isTableMiglRemissioneAvailable = false;
  isTablePegRemissioneAvailable = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }
  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveUCStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }
  // sezione sui pazienti stabili e non stabili globali
  // pazienti con la colite ulcerosa stabili e instabili
  retrieveUCStableAndUnstable() {
    // prendo dal database il numero di tutti i pazienti che soffrono di altro del singolo dottore
    this.subscription = this.doctorService.getUCStableAndUnstable().subscribe(
      dictionary => {
        console.log(dictionary);
        this.stabiliRecidivaUC = Object.values(dictionary)[0].StabiliRecidiva;
        this.stabiliRemissioneUC = Object.values(dictionary)[1].StabiliRemissione;
        this.instabiliMiglRecidivaUC = Object.values(dictionary)[2].InstabiliMiglRecidiva;
        this.instabiliMiglRemissioneUC = Object.values(dictionary)[3].InstabiliMiglRemissione;
        this.instabiliPegRecidivaUC = Object.values(dictionary)[4].InstabiliPegRecidiva;
        this.instabiliPegRemissioneUC = Object.values(dictionary)[5].InstabiliPegRemissione;
        // riempio il vettore della categoria 'recidiva' in ordine stabili, miglioramento e peggioramento
        this.UCRecidiva.push(this.stabiliRecidivaUC.length);
        this.UCRecidiva.push(this.instabiliMiglRecidivaUC.length);
        this.UCRecidiva.push(this.instabiliPegRecidivaUC.length);
        // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
        this.UCRemissione.push(this.stabiliRemissioneUC.length);
        this.UCRemissione.push(this.instabiliMiglRemissioneUC.length);
        this.UCRemissione.push(this.instabiliPegRemissioneUC.length);
        // controllo che i numeri siano messi correttamente
        console.log(dictionary);
        // creo il grafico bar chart
        this.canvas = document.getElementById('myChartUCStableUnstable') as HTMLCanvasElement;
        this.ctx = this.canvas.getContext('2d');
        this.myChartUCStableUnstable = new Chart(this.ctx, {
          type: this.barChartUCStableUnstableType,
          data: {
            labels: this.barChartUCStableUnstableLabels,
            datasets: this.barChartUCStableUnstableData,
          },
          options: {
            responsive: true,
            onClick: event => {
              this.doctorService.getGlobalPatients().subscribe((patients) => {
                localStorage.setItem('patients', JSON.stringify(patients));
              });
              if (this.myChartUCStableUnstable.getElementAtEvent(event).length > 0) {
                if (this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'RECIDIVA'
                  && this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'STABILI') {
                  // setto le altre due tabelle invisibili
                  this.isTableMiglRecidivaAvailable = false;
                  this.isTablePegRecidivaAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.showTableStabiliRecidiva(); // mostro la tabella
                } else if (this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'RECIDIVA'
                  && this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN MIGLIORAMENTO') {
                  // setto le altre tabelle invisibili
                  this.isTableStabiliRecidivaAvailable = false;
                  this.isTablePegRecidivaAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.showTableMiglRecidiva(); // mostro la tabella
                } else if (this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'RECIDIVA'
                  && this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN PEGGIORAMENTO') {
                  // setto le altre due tabelle invisibili
                  this.isTableStabiliRecidivaAvailable = false;
                  this.isTableMiglRecidivaAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.showTablePegRecidiva(); // mostro la tabella
                } else if (this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE'
                  && this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'STABILI') {
                  // setto le altre tabelle invisibili
                  this.isTableStabiliRecidivaAvailable = false;
                  this.isTableMiglRecidivaAvailable = false;
                  this.isTablePegRecidivaAvailable = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.showTableStabiliRemissione(); // mostro la tabella
                } else if (this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE'
                  && this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN PEGGIORAMENTO') {
                  // setto le altre tabelle invisibili
                  this.isTableStabiliRecidivaAvailable = false;
                  this.isTableMiglRecidivaAvailable = false;
                  this.isTablePegRecidivaAvailable = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.showTablePegRemissione(); // mostro la tabella
                } else if (this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE'
                  && this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN MIGLIORAMENTO') {
                  // setto le altre tabelle invisibili
                  this.isTableStabiliRecidivaAvailable = false;
                  this.isTableMiglRecidivaAvailable = false;
                  this.isTablePegRecidivaAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.showTableMiglRemissione(); // mostro la tabella
                }  else {
                }
              }
            },
            onHover: (event) => {
              if (this.myChartUCStableUnstable.getElementAtEvent(event).length > 0) {
                if (this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'RECIDIVA' ||
                  this.myChartUCStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
                  this.setHoverVariable();
                } else {
                  this.unsetHoverVariable();
                }
              }
            },
            scales: {
              xAxes: [{
                display: true,
                stacked: true,
                ticks: {
                  fontSize: 12,
                  fontStyle: 'bold',
                  fontFamily: 'Helvetica',
                  fontColor: '#006192'
                }
              }],
              yAxes: [{
                display: true,
                stacked: true,
                ticks: {
                  fontSize: 12,
                  fontStyle: 'bold',
                  fontFamily: 'Helvetica',
                  fontColor: '#006192'
                }
              }],
            },
            legend: {
              onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
                // tslint:disable-next-line:max-line-length
                if (legendItem.text.length > 0 && (legendItem.text === 'RECIDIVA' || legendItem.text === 'REMISSIONE')) {
                  this.setHoverVariable();
                } else {
                  this.unsetHoverVariable();
                }
              },
              display: true,
              position: 'top',
              align: 'center',
              labels: {
                usePointStyle: true,
                fontColor: '#006192',
                fontSize: 14,
                fontFamily: 'Helvetica',
              }
            },
            tooltips: {
              backgroundColor: '#1c1c1c',
              bodyFontSize: 16,
              titleFontSize: 18,
              cornerRadius: 5,
              caretPadding: 10
            },
            title: {
              display: true,
              text: 'Rettocolite ulcerosa - n° di pazienti stabili e instabili',
              fontColor: '#006192',
              fontSize: 20,
              fontFamily: 'Helvetica',
            },
            hover: {
              mode: 'nearest',
              intersect: true
            }
          }
        });
        this.isDataAvailable = true;

      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }
  // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // nasconde tutte le tabbelle
  hideAllTable() {
    this.isTableMiglRecidivaAvailable = false;
    this.isTablePegRecidivaAvailable = false;
    this.isTableStabiliRecidivaAvailable = false;
    this.isTableStabiliRemissioneAvailable = false;
    this.isTablePegRemissioneAvailable = false;
    this.isTableMiglRemissioneAvailable = false;
  }
  // show table stabili recidiva
  showTableStabiliRecidiva(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'STABILI RECIDIVA';
      if (this.isTableStabiliRecidivaAvailable === true) {
        this.isTableStabiliRecidivaAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.stabiliRecidivaUC);  // creo la tabella stabili recidiva
          this.isTableStabiliRecidivaAvailable = true;
        });
      }
    }
  }
  // show table in miglioramento recidiva
  showTableMiglRecidiva(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN MIGLIORAMENTO RECIDIVA';
      if (this.isTableMiglRecidivaAvailable === true) {
        this.isTableMiglRecidivaAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliMiglRecidivaUC); // creo la tabella instabili in miglioramento
          this.isTableMiglRecidivaAvailable = true;
        });
      }
    }
  }
  // show table in peggioramento recidiva
  showTablePegRecidiva(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN PEGGIORAMENTO RECIDIVA';
      if (this.isTablePegRecidivaAvailable === true) {
        this.isTablePegRecidivaAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliPegRecidivaUC); // creo la tabella instabili in peggioramento
          this.isTablePegRecidivaAvailable = true;
        });
      }
    }
  }
  // show table in peggioramento remissione
  showTablePegRemissione(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN PEGGIORAMENTO REMISSIONE';
      if (this.isTablePegRemissioneAvailable === true) {
        this.isTablePegRemissioneAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliPegRemissioneUC); // creo la tabella instabili in peggioramento remissione
          this.isTablePegRemissioneAvailable = true;
        });
      }
    }
  }
  // show table in miglioramento remissione
  showTableMiglRemissione(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN MIGLIORAMENTO REMISSIONE';
      if (this.isTableMiglRemissioneAvailable === true) {
        this.isTableMiglRemissioneAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliMiglRemissioneUC); // creo la tabella instabili in miglioramento remissione
          this.isTableMiglRemissioneAvailable = true;
        });
      }
    }
  }
  // show table stabili remissione
  showTableStabiliRemissione(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'STABILI REMISSIONE';
      if (this.isTableStabiliRemissioneAvailable === true) {
        this.isTableStabiliRemissioneAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.stabiliRemissioneUC); // creo la tabella stabili in remissione
          this.isTableStabiliRemissioneAvailable = true;
        });
      }
    }
  }
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }
}
